import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';
import { Messages } from '../../codegen/Localize';
import { DatasourceDefinition, FlowDefinition, WorkbookDefinition } from '../../ts/models/ContentDefinitions';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { RevisionHistoryAction as RevisionHistoryService } from '../services/RevisionHistoryAction';
import {
  requestFailed,
  RequestFailedAction
} from '../../app/actions/RequestFailedAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { RevisionHistoryAction } from '../../app/actions/spaces/RevisionHistoryAction';
import { ServiceLocator } from '../../app/ServiceLocator';
import { getCorrectEntityIdForActions } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { reloadSpaceIfUpdatingCurrentSpace } from '../../app/sagas/spaces/content/RefreshContentSagas';

export function* handleRevisionHistoryAction(action: RevisionHistoryAction) {
  try {
    const entityId = yield call(getCorrectEntityIdForActions, action.content.contentType, action.content.id);
    yield call(openRevisionHistoryDialog, { ...action.content, id: entityId });

    const didReload = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.content]);
    if (!didReload) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openRevisionHistoryDialog(content: IContentInfo): ng.IPromise<IResult> {
  const revisionHistoryService = ServiceLocator.get<RevisionHistoryService>('RevisionHistoryAction');
  switch (content.contentType) {
    case WorkbookDefinition.contentType:
      return revisionHistoryService.showWorkbookRevisionHistory(content);
    case DatasourceDefinition.contentType:
      return revisionHistoryService.showDataSourceRevisionHistory(content);
    case FlowDefinition.contentType:
      return revisionHistoryService.showFlowRevisionHistory(content);
  }
}
